import { render, staticRenderFns } from "./EsgBaseDashboardModal.vue?vue&type=template&id=abfc3cb4&scoped=true"
import script from "./EsgBaseDashboardModal.vue?vue&type=script&lang=js"
export * from "./EsgBaseDashboardModal.vue?vue&type=script&lang=js"
import style0 from "./EsgBaseDashboardModal.vue?vue&type=style&index=0&id=abfc3cb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfc3cb4",
  null
  
)

export default component.exports